import { useState } from 'react'
import { getBankUserList } from '../../../../shared/services/BankUserService'
import { ICommonObject } from 'src/app/shared/models/common.model'
import { IGetExportData } from 'src/app/shared/components/common/new-table/table-setting.model'

interface Export {
  chosenColumnNameList: string[]
  pageName: string
  header: string
}

interface IReqBankUserPayload {
  searchTerm?: string
  searchColumns?: Array<string>
  isDesc?: boolean
  sortColumns?: ICommonObject
  pageSize?: number
  pageIndex?: number
  filterOption?: number
  export?: Export
}

interface IBankUserSetup {
  id: string
  lastName: string
  firstName: string
  userName: string
  emailAddress: string
  userRoles: string[]
  status: number
  lastLoggedOn: string
  noEmailContact: boolean
  primaryPhone: string
  mobilePhone: string
  clients: string[]
}

export const useBankUserSetup = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [bankUserList, setBankUserList] = useState<Array<IBankUserSetup>>([])
  const [totalRecords, setTotalRecords] = useState(0)

  const formatBankUserSetupData = (data: any) => {
    return data?.map((item: any) => ({
      ...item,
    }))
  }

  const getBankUserListData = async (params: Partial<IGetExportData>) => {
    try {
      setIsLoading(true)
      /*MUST CHANGE THIS FUCTION*/
      const data = await getBankUserList(params)

      setBankUserList(formatBankUserSetupData(data?.data?.items))

      setTotalRecords(data?.data?.total)
      return data?.data
    } catch (e) {
      console.log('ERROR: ', e)
    } finally {
      setIsLoading(false)
    }
  }

  return { bankUserList, totalRecords, getBankUserListData, isLoading }
}

export const formatPhoneNumber = (value: string) => {
  const [countryCode, phoneNumber] = value.split(';#')

  return countryCode ? `(+${countryCode}) ${phoneNumber}` : phoneNumber
}
